import React, { useState, useEffect, useCallback } from 'react'
import Style from './index.module.css'
import API from '../../../ApiConfig'
import { COPY_TO_MASTER_FORMS, CREATE_FORM, GET_EMP_DOCUMENTS, GET_VERIFIER_DEFAULT_FIELDS_FOR_DOCS, GET_VERIFIER_MASTER_DOCUMENTS, UPDATE_VERIFIER_FORM } from "../../../Utils/constant";
import { AuthConsole, Delay, ObjectNotEmpty, _ToNormal } from '../../../Utils/helper';
import { Icon } from 'react-icons-kit'
import { basic_trashcan as Trash } from 'react-icons-kit/linea/basic_trashcan'
import CustomCheckDropDown from '../../../components/CustomCheckDropDown';
import { useNavigate, useLocation, useParams } from "react-router-dom";
import cogoToast from 'cogo-toast-react-17-fix';
import Loader from '../../../components/Loader';
import SlideUpWrapper from '../../../components/Transitions/SlideUpWrapper';

import { informationCircled } from 'react-icons-kit/ionicons/informationCircled'
import Breadcrumb from '../../../components/Verifier/breadcrumb/BreadCrumb';
import { ic_check } from 'react-icons-kit/md/ic_check'
export default function VerifierFields({ id, isEdit }) {
  const [search, setSearch] = useState('')
  const [searchList, setSearchList] = useState(Array(6).fill().map((_, index) => index + 1))
  const [loading, setLoading] = useState(false)
  const [submit, setSubmit] = useState(false)
  const [tagList, setTaglist] = useState([{ 'checked': true }, { 'checked': true }])
  const navigate = useNavigate();
  const location = useLocation()
  const [description, setDescription] = useState({})
  const [documentTagList, setDocumentsTagList] = useState([])

  const [documentStates, setDocumentStates] = useState({})

  const [addedDocuments, setAddedDocuments] = useState([]);
  const locState = location.state
  // console.log(locState);


  let { uuid } = useParams();
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        if (locState.form_category == '2') { 
          const res = await API.get(isEdit ? GET_EMP_DOCUMENTS + '?form_uuid=' + uuid : GET_EMP_DOCUMENTS);
            if (!res.data || !res.data.data) {
            }
            const data = res.data.data;
            let documents = data.master_documents
            if (documents) {
              const initialDocuments = documents.map(doc => ({
                ...doc,
                checked: false
              }));
              const initialDocumentStates = initialDocuments.reduce((acc, doc) => {
                acc[doc.id] = {
                  count: 0
                };
                return acc;
              }, {})
              setDocumentsTagList(initialDocuments);
              setSearchList(initialDocuments);
              setDocumentStates(initialDocumentStates);
            }
            if (isEdit) handleEditDocument(data?.added_documents)
        }
        else {
          if (locState.state === "Verification fields" || locState.required_doc_fields && locState.required_doc_fields.length > 0) {
            const res = await API.get(GET_VERIFIER_DEFAULT_FIELDS_FOR_DOCS);
            const data = res.data.data;
            let result = [];
            Object.keys(data).map(item => {
              let obj = {}
              obj = data[item]
              obj.name = item
              obj.checked = false
              result.push(obj)
            });

            setTaglist(result);
            setSearchList(result);

            if (isEdit) handleEditData(result);
          }
          else if (locState.state === "Verification documents" || locState.required_documents && locState.required_documents.length > 0) {
            // GET_VERIFIER_MASTER_DOCUMENTS
            const res = await API.get(isEdit ? GET_VERIFIER_MASTER_DOCUMENTS + '?form_uuid=' + uuid : GET_VERIFIER_MASTER_DOCUMENTS);
            if (!res.data || !res.data.data) {
            }
            const data = res.data.data;
            let documents = data.master_documents
            if (documents) {
              const initialDocuments = documents.map(doc => ({
                ...doc,
                checked: false
              }));
              const initialDocumentStates = initialDocuments.reduce((acc, doc) => {
                acc[doc.id] = {
                  count: 0
                };
                return acc;
              }, {})
              setDocumentsTagList(initialDocuments);
              setSearchList(initialDocuments);
              setDocumentStates(initialDocumentStates);
            }
            if (isEdit) handleEditDocument(data?.added_documents)


          }
        }
      } catch (error) {
        // console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [locState.state, isEdit])

  function handleEditData(list) {
    let locState = location.state.required_doc_fields
    if (locState && locState.length > 0) {
      locState.map(editItem => {
        list.map(item => {
          if (item.name === editItem.doc_field_name) {
            item.checked = true
            item.isOld = true
            item.sourceSelected = true
            item.data.map(subItem => {
              if (editItem.linked_documents.includes(subItem.master_document_name)) {
                subItem.checked = true
                subItem.isOld = true
              }
            })
          }
        })
      })

      setTaglist(list)
      setSearchList(list)
    }
  }
  function addRemoveTag(index, val) {
    let temp = [...tagList]
    temp[index].checked = val
    setTaglist(temp)
  }

  function handleSourceChange(sIndex, lIndex) {
    let temp = [...tagList]
    if (temp[lIndex].data[sIndex].isOld) {
      cogoToast.info('You can not change this!')
      return
    }
    temp[lIndex].data[sIndex].checked = !temp[lIndex].data[sIndex].checked
    let sourceSelected = false
    sourceSelected = temp[lIndex].data.some(item => item.checked)
    temp[lIndex].sourceSelected = sourceSelected
    setTaglist(temp)
  }
  async function handleSubmit() {
    let notValid = false
    let form_name = locState?.formName || ''
    let form_category = locState?.form_category || ""
    let doc_field_payload = {
      verifier_id: parseInt(id),
      form_name:form_name,
      form_category:form_category,
      form_type:"doc_field",
      form_scope:"predefined",
      required_doc_fields:[]          
    }
    let temp = tagList.filter(item => item.checked)
    temp.map(item => {
      if (!item.sourceSelected) notValid = true
      else {
        item.data.forEach(subItem => {
          if (subItem.checked) {
            const masterId = subItem.doc_field_id;
              const linkedId = subItem.master_document
              let isMasterDocIDexists = doc_field_payload.required_doc_fields
              .find(obj => obj.master_doc_field_id === masterId)
              if (isMasterDocIDexists) {
                isMasterDocIDexists.linked_documents_id.push(linkedId);
              }

              else{
                  let docItem = isEdit 
                    ? { linked_documents_id: [] } 
                    : { master_doc_field_id: masterId, linked_documents_id: [] };
              
                  docItem.master_doc_field_id = masterId;
                  docItem.linked_documents_id.push(linkedId);
              
                  doc_field_payload.required_doc_fields.push(docItem);
              }
          }
        })
      }
    })
    AuthConsole(doc_field_payload)
    
    if (notValid) {
      cogoToast.error('Please select source for all documents')
      return
    }
    let URL = isEdit ? UPDATE_VERIFIER_FORM + uuid : CREATE_FORM
    if (!isEdit && form_name.length === 0) {
      cogoToast.error('Please enter a form name first!')
      return
    }
    setLoading(true)
    setSubmit(true)
    await Delay()
    API.post(URL, doc_field_payload)
      .then(res => {
        if (res.data.status === 200) {
          cogoToast.success(res.data.message)
          if (location.state?.navigateBack)
            navigate('/dashboard/forms/selectForms', { state: { form: res.data.data[0] } })
          else
            if (res.data.status == 200) {
              if (id == 2) {
                copytoMaster(res.data.data.form_id)
              }
              else {
                navigate('../verifier-forms');
              }
            }
        }
        else
          cogoToast.error('Something went wrong')
      })
      .catch(err => {
        cogoToast.error(err.response.data.detail)
      })
      .finally(() => {
        setLoading(false)
        setSubmit(false)
      })
  }


  const handleInput = useCallback((description, docId) => {
    setDescription(prev => ({
      ...prev,
      [docId]: description
    }));
  }, [])
  const handleAddDocument = (doc) => {
    setDocumentStates(prev => ({
      ...prev,
      [doc.id]: {
        count: 1
      }
    }))
    doc.checked = true;
    setAddedDocuments(prev => {
      const exists = prev.some(item => item.id === doc.id)
      if (!exists) {
        return [
          ...prev,
          { ...doc, uniqueKey: `${doc.id}_1` }
        ]
      }
      return prev;
    })
  }
  const handleIncrementCounter = (doc) => {
    setDocumentStates(prev => {
      const currentState = prev[doc.id]
      return {
        ...prev,
        [doc.id]: {
          ...currentState,
          count: currentState.count + 1
        }
      };

    })
  }

  const handleDecrementCounter = (doc) => {
    setDocumentStates(prev => {
      const currentState = prev[doc.id]
      const newCount = Math.max(0, currentState.count - 1)
      if (newCount === 0) {
        setAddedDocuments(prev =>
          prev.filter(item => item.id !== doc.id)
        )
        doc.checked = false
      }
      setDescription((prev) => {
        const { [doc.id]: _, ...rest } = prev;
        return rest;
      })
      return {
        ...prev,
        [doc.id]: {
          ...currentState,
          count: newCount,
        },
      }
    })

  }

  const handleRemoveAddedDocument = (item) => {

    setAddedDocuments(prev =>
      prev.filter(doc => doc.id !== item.id)
    )
    setDocumentStates(prev => ({
      ...prev,
      [item.id]: {
        count: 0
      }
    }))
    setDocumentsTagList(prevList =>
      prevList.map(doc =>
        doc.id === item.id
          ? { ...doc, checked: false }
          : doc
      )
    );
    setDescription((prev) => {
      const { [item.id]: _, ...rest } = prev;
      return rest;
    })
  }

  const handleEditDocument = (EditDocument) => {
    const addedDetails = EditDocument.details || []
    const formataddedDocument = addedDetails.map((doc) => ({
      id: doc.master_document_id,
      name: doc.master_dcoument_name,
      checked: true,
      description: doc.comment || "",
      count: doc.count || 0,
      isOld: doc.is_old || false,
      uniqueKey: `${doc.master_document_id}_${doc.count}`
    })
    )
    const initialDocumentStates = addedDetails.reduce((acc, doc) => {
      acc[doc.master_document_id] = {
        count: doc.count || 0,
      };
      return acc;
    }, {})
    const initialDescriptions = addedDetails.reduce((acc, doc) => {
      acc[doc.master_document_id] = doc.comment || "";
      return acc;
    }, {})
    setDocumentStates(initialDocumentStates);
    setAddedDocuments(prev => [...prev, ...formataddedDocument]);
    setDescription(initialDescriptions);

  }

  const copytoMaster = (form_id) => {
    API.post(COPY_TO_MASTER_FORMS + form_id)
      .then(res => {
        if (res.status === 200) {
          navigate(`/forms`)
        }
      })
  }

  const handleDocumentSubmit = () => {
    const form_category = locState?.form_category
    if (addedDocuments.length > 0) {
      const masterDocuments = addedDocuments
        .map(doc => ({
          master_document_id: doc.id,
          comment: description[doc.id] || "",
          count: documentStates[doc.id].count
        }));
      API.post(CREATE_FORM, {
        "form_uuid": uuid ? uuid : "",
        "form_name": locState.formName ? locState.formName : locState.form_name ? locState.form_name : null,
        "verifier_id": id,
        "required_documents": masterDocuments,
        "form_category": form_category,
        "form_scope":"predefined",
        "form_type":"document",
      })
        .then(res => {
          if (res.data.status == 200) {
            if (id == 2) {
              copytoMaster(res.data.data.form_id)
            }
            else {
              navigate('../verifier-forms');
            }
          }
        }

        ).catch(err => {
          cogoToast.error(err.response.data.detail[0])
        })
    }
    else {
      cogoToast.error("Please add document")
    }
  }
  // console.log(addedDocuments);
  // console.log(documentStates);

  return (
    <div style={{ width: '100%' }}>

      <SlideUpWrapper>
        {location.pathname.includes('/company') ? null :
          <Breadcrumb pos={2} title="Create form" category={"verifier"} />}
        <div className={Style.formInputContainer}>
          <div className={Style.FormInfo}>
            <div style={{ width: "100%", display: "flex", gap: "15px", alignItems: "center" }}>
              <span style={{ paddingRight: "10px" }}>Form Name</span>
              <input type='text' className={Style.FormInput} value={locState.formName ? locState.formName : locState.form_name ? locState.form_name : null} disabled />
              <div><Icon icon={informationCircled} /></div>
              Choose the {locState.state === "Verification fields" || locState.required_doc_fields && locState.required_doc_fields.length > 0 ? "fields" : "documents"} you want to verify, and then
              select the corresponding proof document type.
            </div>
          </div>
        </div>
        <div className={Style.container}>
          <Loader isOpen={loading} />
          <div className={Style.header}>
            {/* <h2 className={Style.headerTitle}>Verification Fields </h2> */}
            {/* {!isEdit ? <span className={Style.formname}>{locState?.formName}</span> : null} */}
          </div>
          <div className={Style.wrapper}>
            {/* Left Section */}
            <section className={Style.left}>
              <div>
                <div className={Style.search}>
                  <h1 className={Style.searchTitle}>{locState.state === "Verification fields" || locState.required_doc_fields && locState.required_doc_fields.length > 0 ? "Select Verification Fields" : "Select document"}</h1>
                  <p className={Style.subTitle}>{locState.state === "Verification fields" || locState.required_doc_fields && locState?.required_doc_fields?.length > 0 ? "Add fields" : "Add documents"}</p>
                  <div className={Style.searchbox}>
                    <div className={Style.inputbox}>
                      <img src='/searchoutline.svg' />
                      <input className={Style.input} onChange={e => setSearch(e.target.value)} value={search} />
                      {search ? <img src='/x.svg' onClick={e => setSearch('')} className={Style.closeSearch} /> : <></>}
                    </div>
                    <button className={Style.searchButton} >Search</button>
                  </div>
                </div>

                <div className={Style.tagMenu}>
                  <table>
                    <tbody>
                      <tr>
                        <th className={Style.th}>Name</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
                {loading ?
                  (
                    [...Array(5)].map((_, index) => (
                      <div style={{ display: "flex", flexDirection: 'row', justifyContent: "space-between", gap: "5rem", marginTop: "1rem" }} key={index}>
                        <div className="shimmer" style={{ width: '20rem', height: "3rem" }}></div>
                        <div className="shimmer" style={{ width: '2.5rem', height: "2.5rem", borderRadius: "100%" }}></div>
                      </div>
                    ))
                  ) :
                  (
                    <div className={Style.select}>
                      {searchList.map((i, index) => {
                        if (search.length > 0 && !(i.name).toLowerCase().includes(search.toLowerCase())) return null
                        const documentState = documentStates[i.id] || { count: 0 }

                        return <div className={Style.listItems} key={i.field_id}>
                          <div>
                            <div className={Style.listTitle} style={{ margin: "7px 0px" }}>
                              {_ToNormal(i.name)}
                            </div>
                            {locState.state == "Verification fields" || locState.required_doc_fields && locState.required_doc_fields.length > 0 ?
                              <div className={Style.listDesc}>
                                in {i.count} documents
                              </div> :
                              <div className={Style.listDesc} style={{ width: "12rem" }}>
                                {i.description}
                              </div>}

                          </div>

                          {/* <div className={i.checked ? Style.added : Style.add} onClick={() => addRemoveTag(index, true)}>
                            <span>{i.checked ? <> <Icon icon={ic_check} /> Added</> : "+ Add"}</span>
                          </div> */}


                          {locState.state === "Verification fields" || locState.required_doc_fields && locState.required_doc_fields.length > 0 ?
                            (<div className={i.checked ? Style.added : Style.add} onClick={() => { i.isOld ? null : addRemoveTag(index, !i.checked) }}>
                              <span>{i.checked ? <> <Icon icon={ic_check} /> Added</> : "+ Add"}</span>
                            </div>)
                            :
                            (
                              <div className={documentState?.count > 0 && i.document_type === "NID" ? Style.added : documentState?.count > 0 && i.document_type === "NON-NID" ? Style.addCounter : Style.add}>
                                {documentState?.count === 0 ? (<div onClick={() => handleAddDocument(i)}>+ Add</div>) :
                                  i.document_type === "NID" ? <div className={Style.added}><Icon icon={ic_check} /> Added</div> :
                                    <>
                                      <button className={Style.decrementCounter} onClick={() => { documentState?.count === addedDocuments[index]?.count ? cogoToast.warn("Yout cannot remove this") : handleDecrementCounter(i) }}>-</button>
                                      <div className={Style.count}>{documentStates[i.id].count}</div>
                                      <div className={Style.incrementCounter} onClick={() => handleIncrementCounter(i)}>+</div>
                                    </>}
                              </div>
                            )
                          }
                        </div>
                      }
                      )}
                    </div>)
                }

              </div>

            </section>
            {/* Right Section */}
            <section className={Style.right}>
              <div className={Style.rTitle}>
                <h1 style={{ marginTop: 8, marginBottom: 8 }}>{loading ? <div className="shimmer" style={{ width: "10rem" }}></div> : locState.state === "Verification fields" || locState.required_doc_fields && locState.required_doc_fields.length > 0 ? <>Add Fields({tagList.filter(item => item.checked).length})</> : <>Added document({addedDocuments.length})</>}</h1>
                {locState.state === "Verification fields" || locState.required_doc_fields && locState.required_doc_fields.length > 0 ?
                  (tagList.some(item => item.checked) ? <div className={`${Style.submitBtn}`}>
                    <button onClick={e => handleSubmit()} className='primaryBtn' >{submit ? <>Submitting...</> : <>Submit</>}</button>
                  </div> : null) :
                  (addedDocuments.some(item => item.checked) ? <div className={`${Style.submitBtn}`}>
                    <button onClick={e => handleDocumentSubmit()} className='primaryBtn' >{submit ? <>Submitting...</> : <>Submit</>}</button>
                  </div> : null)
                }
              </div>
              <table>
                <tr>
                  {locState.state === "Verification fields" || locState.required_doc_fields && locState.required_doc_fields.length > 0 ?
                    <>
                      <th className={Style.th}>Variable</th>
                      <th className={Style.th}>Acceptable documents</th>
                    </> :
                    <>
                      <th className={Style.th}>DOCUMENT TYPE</th>
                      <th className={Style.th}>NO. OF DOCUMENTS</th>
                      <th className={Style.th}>DESCRIPTION</th>

                    </>
                  }

                  <th className={Style.th}>Action</th>
                </tr>
                {loading ?
                  (
                    [...Array(2)].map((_, index) => (
                      <tr key={index}>
                        <td className={Style.td}>
                          <div className="shimmer" style={{ width: '7rem' }}></div>
                        </td>
                        <td className={Style.td}>
                          <div className="shimmer" style={{ width: '7rem' }}></div>
                        </td>
                        <td className={Style.td}>
                          <div className="shimmer" style={{ width: '7rem' }}></div>
                        </td>
                        <td className={Style.td}>
                          <div className="shimmer" style={{ width: '2rem', height: "2rem", borderRadius: "100%" }}></div>
                        </td>
                      </tr>
                    ))
                  ) : locState.state === "Verification fields" || locState.required_doc_fields && locState.required_doc_fields.length > 0 ?
                    (tagList?.map((item, index) => {
                      if (!item.checked) return null
                      return (
                        <tr key={index}>
                          <td className={Style.td}>{item.name}</td>
                          <td className={Style.td}>
                            <div className={Style.source} style={{ width: '25rem' }}>
                              <CustomCheckDropDown isSelected={item.sourceSelected} label="Select Source" onSelect={e => handleSourceChange(e, index)} list={item.data} displayKey="master_document_name" selectedOption={item?.selected} />
                            </div>
                          </td>

                          <td className={Style.td}><span onClick={e => item?.isOld ? cogoToast.warn('You can not delete this!') : addRemoveTag(index, false)} className={item.isOld ? Style.trashDisable : Style.trash}>X Remove</span></td>
                        </tr>
                      )
                    })) : locState?.state === "Verification documents" || locState.required_documents && locState.required_documents.length > 0 ?

                      (addedDocuments?.map((item, index) => {
                        if (!item.checked) return null
                        return (
                          <>
                            <tr key={item.id}>
                              <td className={Style.td}>{item.name && item?.name}</td>
                              <td className={Style.td}>
                                <div className={Style.source}>
                                  <div className={Style.counts}>{documentStates[item.id]?.count}</div>
                                </div>
                              </td>
                              <td className={Style.td}>
                                <div className={Style.source} style={{ width: '20rem' }}>
                                  <input className={Style.description} value={description[item.id] || ''} placeholder='Enter Description' key={index} onChange={(e) => handleInput(e.target.value, item.id)} />
                                </div>
                              </td>
                              <td className={Style.td}><span onClick={e => item?.isOld ? cogoToast.warn('You can not delete this!') : handleRemoveAddedDocument(item)} className={item.isOld ? Style.trashDisable : Style.trash}>X Remove</span></td>
                            </tr>
                          </>
                        )
                      })
                      ) : null
                }
              </table>

            </section>
          </div>
        </div>
      </SlideUpWrapper>
    </div>

  )
}
